import { Injectable } from '@angular/core';
import { FIELD_TYPE } from 'dspx-core';

@Injectable({
  providedIn: 'root'
})
export class FormCommonHelperService {
  protected fieldTypeList: string[] = [
    FIELD_TYPE.tabs,
    FIELD_TYPE.page,
    FIELD_TYPE.pageRepeating,
    FIELD_TYPE.summaryPage,
    FIELD_TYPE.section,
    FIELD_TYPE.sectionRepeating,
    FIELD_TYPE.cardsetTabs,
    FIELD_TYPE.cardsetTabsFlat,
    FIELD_TYPE.cardsetPage,
    FIELD_TYPE.cardsetPageRepeating,
    FIELD_TYPE.cardsetSection,
    FIELD_TYPE.cardsetSectionRepeating,
  ];


  public isReadOnly(): boolean {
    return true;
  }

  public ensurePathExists(obj, path) {
    return path.split('.').reduce((acc, key) => {
      if (!acc[key]) {
        acc[key] = {}; // Create missing object
      }
      return acc[key];
    }, obj);
  }

  /**
   *
   * This method will extract the field control from the baseform fields array
   * Usage: const field = this.findFieldByKey(this.baseForm.fields, "key");
   * Instead of performing the following this.baseForm.fields[0].fieldGroup[0].fieldGroup[1].fieldGroup[0].fieldGroup[3].fieldGroup[9];
   * this method recursively iterates through the fieldGroups to find the user input control via the key field
   * @param {any[]} fields The fields array (required)
   * @param {string} key The string key used to match the field.key, eg complianceOutcome (required)
   *
   */
  public findFieldByKey(fields: any[], key: string): any | null {
    for (const field of fields) {
      if (field.fieldGroup) {
        const nestedField = this.findFieldByKey(field.fieldGroup, key);
        if (nestedField) {
          return nestedField;
        }
      }

      if (field && !this.fieldTypeList.includes(field?.type)) {
        if (field.key === key) {
          return field;
        }
      }
    }

    return null;
  }

}
